import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ResposeGeneric } from '../../../core/shared/respose-generic';
import { UtilityService } from '../../../core/shared/utility.service';
import { ChangedVersion } from './changed-version.model';

@Injectable()
export class ProgramService {

  uriProgram = environment.urlServices + 'programas';
  uriProgramsParams =  this.uriProgram + '/parametros';
  uriProgramsSubjects =  this.uriProgram + '/materias';
  uriProgramsVersions =  this.uriProgram + '/versiones';
  uriProgramsVersionsStudent =  this.uriProgramsVersions + '/estudiantes';
  uriProgramsByStudent =  this.uriProgram + '/pifle/validar';
  uriFacultyGrant =  this.uriProgram + '/facultades/validar';
  uriProgramBoss = this.uriProgram + '/jefeDpto';
  uriProgramAsis = this.uriProgram + '/AsisUnidadAcad';

  constructor(private httpClient: HttpClient, private utilityService: UtilityService) { }

  isBelongPifle(programa, version): Observable<ResposeGeneric> {
    const parameters = { programa : programa , version: version};
    return this.httpClient.get<ResposeGeneric>(
            this.utilityService.addQueryParam(this.uriProgramsByStudent, parameters));
  }

  isFacultyAvaible(cedula, programa): Observable<ResposeGeneric>  {
    const parameters = { cedula: cedula , programa : programa };
    return this.httpClient.get<ResposeGeneric>(
      this.utilityService.addQueryParam(this.uriFacultyGrant, parameters));
 }

 getParamsProgram(program): Observable<ResposeGeneric> {
  const parameters = { programa: program};
  return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriProgramsParams, parameters));
 }

 getProgramsList(facultad): Observable<ResposeGeneric> {
  const parameters = { facultad: facultad};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriProgram, parameters));
 }

 getProgramsListBoss(facultad, cedula): Observable<ResposeGeneric> {
  const parameters = { facultad: facultad, cedula: cedula};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriProgramBoss, parameters));
 }

 getProgramsListAsis(facultad, cedula): Observable<ResposeGeneric> {
  const parameters = { facultad: facultad, cedula: cedula};
    return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriProgramAsis, parameters));
 }

 getSubjectByProgram(program, version, subject, name): Observable<ResposeGeneric> {
  const parameters = { programa: program , version: version, materia: subject, nombre: name};
  return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriProgramsSubjects, parameters));
 }

 getVersions(program) {
  const parameters = { programa: program};
  return this.httpClient.get<ResposeGeneric>(this.utilityService.addQueryParam(this.uriProgramsVersions, parameters));
 }

 setVersionProgramStudent(changedVersion: ChangedVersion): Observable<ResposeGeneric> {
  return this.httpClient.post<ResposeGeneric>(this.uriProgramsVersionsStudent, changedVersion);
 }

}
